export enum AuthActionTypeEnum {
    DeleteInstallations,
}
